import React, { useState, useEffect, useRef } from "react"
import _ from "lodash"
import {
  Grid,
  Typography,
  IconButton,
  Tooltip,
  Button,
} from "@material-ui/core"
import {
  CloseRounded,
  StorefrontOutlined,
  ReportProblemOutlined,
} from "@material-ui/icons"
import { useHistory } from "react-router-dom"
import Hierarchy from "../Hierarchy"
import Table from "./Table"
import api from "../../../services/masterData/locations/api"
import { productDataApiMethods } from "../../../services/masterData/products/api"
import * as Adm from "@adm"
import styled from "styled-components"
import { ConfirmationDialog } from "@features"
import * as ServiceAPI from "@services"
import SearchBar from "../../../components/AdmKit/SearchBar/SearchBar"
import * as constantsAPI from "@constants"
import { Helmet } from "react-helmet"
import NavigateBeforeOutlinedIcon from "@material-ui/icons/NavigateBeforeOutlined"
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined"
import { useDispatch, useSelector } from "react-redux"
import { AppContext } from "@utils"
import TenantBreadcrumb from "../../../components/Tenant_Kit/TenantBreadcrumb"
const { APIEndPoint: { API_END_POINTS = {} } = {} } = constantsAPI || {}

const PageHeaderBreadcrumbKit = styled(Grid)`
  button {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-left: 18px;
    padding-right: 18px;
    max-width: unset;
  }
  margin-bottom: 24px;
  border-bottom: 1px #e0e0e0 solid;
  padding-bottom: 15px;
`
const HierarchyMapping = (props) => {
  const {
    isWriteAllowed,
    isDeleteAllowed = false,
    columns = null,
    pageName = "",
    isNotModalView = false,
    isGridType = "1",
    notFoundText = "No records found",
    onUpdateTrigger = () => "",
    isLive = false,
    moduleType = "",
  } = props || {}

  const isMobile = window.innerWidth <= 580
  const { getStoreType = [], getStoreSelectedType = [] } = React.useContext(
    AppContext
  )
  let history = useHistory()
  const userProfileDetails =
    useSelector((state) => state.adminReducer.userProfileDetails) || {}
  let productURL =
    props.lookupType === "product" ||
    history?.location?.pathname ===
      `/${userProfileDetails?.roleType}/master-data/products_pm/productMapping`
  const isKC = history?.location?.pathname?.includes("edgeDevice")
  const {
    isGrid = false,
    isLookUp = false,
    handleCloseLookUp = () => {},
    handleLookUpPrimaryAction = () => {},
    selectedItems = [],
    lookupType = productURL ? "product" : "location",
    titlePath = productURL ? "category_name" : "name",
    idPath = productURL ? "categoryId" : "hierarchyId",
    parentIdPath = productURL ? "mapped_parent_categories" : "parent",
    isInventory = false,
    hideCheckBoxAll = false,
    sdcFilter = [],
    dataUniqueIdPath = "_id",
    ShowCheckBox = true,
    locationBasedProduct = false,
  } = props
  const dataFetchMethod =
    lookupType === "product"
      ? productDataApiMethods.updateProductCategoryMappings
      : lookupType === "storage"
      ? api.updateStorageHierarchyMappings
      : api.updateLocationHierarchyMappings
  const [selectedHierarchyIds, setHierarchySelectedIds] = useState([])
  const [triggerDataFetch, setTriggerDataFetch] = useState({
    uncategorized: false,
    categorized: false,
  })
  const [getTabIndex, setTabIndex] = React.useState(0)
  const [getActiveFilter, setActiveFilter] = useState("All")
  const [storeInfoView, setStoreInfoView] = useState("available")
  const [alert, setAlert] = useState(false)
  const [alertMessage, setAlertMessage] = useState("")
  const [alertType, setAlertType] = useState("")
  const [loading, setLoading] = useState(false)
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)
  const [reDirect, setReDirect] = useState(false)
  const [selectedDisAssociateItems, setSelectedDisAssociateItems] = useState([])
  const [SDCFilter, setSDCFilter] = useState(sdcFilter)
  const [locationTypeList, setlocationTypeList] = useState([])
  const [toggle, setToggle] = useState(false)
  const [getLocationLMList, setLocationLMList] = useState({
    data: { data: { total_available_stores: 0, total_stores_with_issues: 0 } },
  })

  const handleClick = () => {
    setToggle(!toggle)
  }

  const [dropDownSelectedItems, setDropdownSelectedItems] = useState({
    city: [],
    state: [],
    brand: [],
    manufacturer: [],
  })

  const initialDataState = {
    page: 1,
    showMore: false,
    limit: 10,
    searchTerm: "",
  }

  const dropdownList = {
    list: [],
    totalDocs: "",
    nextPage: null,
  }

  const [dropdownDataState, setDropdownDataState] = useState({
    city: initialDataState,
    state: initialDataState,
    brand: initialDataState,
    manufacturer: initialDataState,
  })

  const [dropDownList, setDropdownList] = useState({
    city: dropdownList,
    state: dropdownList,
    brand: dropdownList,
    manufacturer: dropdownList,
  })

  const [searchTerm, setSearchTerm] = React.useState("")
  const savedCallback = useRef()

  useEffect(() => {
    setSelectedDisAssociateItems(selectedDisAssociateItems)
  }, [selectedDisAssociateItems])

  const BreadcrumbList1 = [
    { name: "Master Data", disable: true },
    { name: "Products", disable: true },
    { name: "Category Mapping" },
  ]
  const BreadcrumbList = [
    { name: "Master Data", disable: true },
    { name: "Stores", disable: true },
    { name: "Hierarchy Mapping" },
  ]

  const disAssociateConformDialog = async (selectedItems, id, callback) => {
    setAlert(false)
    savedCallback.current = callback
    if (selectedItems?.length === 0 || id === undefined) {
      await setAlertType("error")
      await setAlertMessage(
        lookupType === "product" ? "Select a Category" : "Select a Hierarchy"
      )
      await setAlert(true)
    } else {
      setSelectedDisAssociateItems(selectedItems)
      setOpenConfirmationDialog(true)
    }
  }

  useEffect(() => {
    setTriggerDataFetch({ uncategorized: false, categorized: true })
  }, [isLookUp, selectedDisAssociateItems])

  const handleCustomCloseRedirect = () => {
    let bodyData = {}
    if (lookupType === "product") {
      bodyData = {
        item_ids: _.map(selectedDisAssociateItems, (o) => _.get(o, "item_id")),
        category_Id: "",
      }
    } else {
      bodyData = {
        locationIds: _.map(selectedDisAssociateItems, (o) =>
          _.get(o, "locationId")
        ),
        hierarchyId: "",
      }
    }
    dataFetchMethod(bodyData)
      .then((resp) => {
        setTriggerDataFetch({ uncategorized: true, categorized: true })
        if (_.isFunction(savedCallback.current())) savedCallback.current()
        setAlertType(_.get(resp, "data.status", "error"))
        setAlertMessage(
          `Selected ${lookupType}(s) disassociated from "${
            selectedHierarchyIds[1] || "-"
          }" ${
            lookupType === "product" ? "category" : "hierarchy"
          } successfully`
        )
        setLoading(false)
        setAlert(true)
      })
      .catch((err) => {})
    setAlert(false)
    setLoading(true)
    setOpenConfirmationDialog(false)
    setSelectedDisAssociateItems([])
  }

  const handleMapping = async (selectedItems, id, callback) => {
    setAlert(false)
    if (selectedHierarchyIds.length === 0 || id === undefined) {
      await setAlertType("error")
      await setAlertMessage(
        lookupType === "product" ? "Select a Category" : "Select a Hierarchy"
      )
      await setAlert(true)
    } else {
      let bodyData = {}
      if (lookupType === "product") {
        bodyData = {
          item_ids: _.map(selectedItems, (o) => _.get(o, "item_id")),
          category_Id: id,
        }
      } else {
        bodyData = {
          locationIds: _.map(selectedItems, (o) => _.get(o, "locationId")),
          hierarchyId: id,
        }
      }
      dataFetchMethod(bodyData)
        .then((resp) => {
          setTriggerDataFetch({ uncategorized: true, categorized: true })
          if (_.isFunction(callback)) callback()
          setAlertType(_.get(resp, "data.status", "error"))
          setAlertMessage(
            `Selected ${lookupType}(s) associated to "${
              selectedHierarchyIds[1] || "-"
            }" ${
              lookupType === "product" ? "category" : "hierarchy"
            } successfully`
          )
          setAlert(true)
          setLoading(false)
        })
        .catch((err) => {})

      setAlert(false)
      setLoading(true)
    }
  }
  useEffect(() => {
    if (isLookUp) {
      if (lookupType === "location") {
        fetchLocationType()
      }
    }
  }, [])

  useEffect(() => {
    setSearchTerm(searchTerm)
  }, [searchTerm])

  useEffect(() => {
    if (lookupType === "location") {
      fetchCityData()
    } else {
      fetchBrandData()
    }
  }, [dropdownDataState.city, dropdownDataState.brand])

  useEffect(() => {
    if (lookupType === "location") {
      fetchStateData()
    } else {
      fetchManufacturerData()
    }
  }, [dropdownDataState.state, dropdownDataState.manufacturer])

  useEffect(() => {
    setDropdownSelectedItems(dropDownSelectedItems)
  }, [dropDownSelectedItems])

  useEffect(() => {
    setDropdownDataState(dropdownDataState)
  }, [dropdownDataState])

  useEffect(() => {
    setDropdownList(dropDownList)
  }, [dropDownList])

  const fetchLocationType = async () => {
    let response = await ServiceAPI.getStoreCommonData(
      API_END_POINTS.getlocationtypes
    )
    let { data = {} } = response || {}
    let locationTypeList = []
    data?.data?.map((o) => locationTypeList.push(o.locationTypeName))
    setlocationTypeList(locationTypeList)
  }

  const fetchCityData = async () => {
    const cityDataState = dropdownDataState.city
    let bodyData = {
      ...cityDataState,
    }
    delete bodyData["showMore"]
    let response = await ServiceAPI.fetchStoreCommonData(
      API_END_POINTS.getAllCities,
      bodyData
    )
    let { data: { data = {} } = {} } = response || {}
    let cityList = []
    data?.docs?.map((o) => cityList.push({ id: o._id, name: o.name }))
    if (cityDataState?.showMore === false) {
      setDropdownList((c) => ({
        ...c,
        city: {
          ...c.city,
          list: cityList,
          totalDocs: data.totalDocs,
          nextPage: data.nextPage,
        },
      }))
    } else {
      let addCityList = dropDownList.city.list
      addCityList.push(...cityList)
      setDropdownList((c) => ({
        ...c,
        city: {
          ...c.city,
          list: addCityList,
          totalDocs: data.totalDocs,
          nextPage: data.nextPage,
        },
      }))
    }
  }

  const fetchStateData = async () => {
    const regionDataState = dropdownDataState.state
    let bodyData = {
      ...regionDataState,
    }
    delete bodyData["showMore"]
    let response = await ServiceAPI.fetchStoreCommonData(
      API_END_POINTS.getAllStates,
      bodyData
    )
    let { data: { data = {} } = {} } = response || {}
    let stateList = []
    data?.docs?.map((o) => stateList.push({ id: o._id, name: o.name }))
    if (regionDataState?.showMore === false) {
      setDropdownList((c) => ({
        ...c,
        state: {
          ...c.state,
          list: stateList,
          totalDocs: data.totalDocs,
          nextPage: data.nextPage,
        },
      }))
    } else {
      let addStateList = dropDownList.state.list
      addStateList.push(...stateList)
      setDropdownList((c) => ({
        ...c,
        state: {
          ...c.state,
          list: addStateList,
          totalDocs: data.totalDocs,
          nextPage: data.nextPage,
        },
      }))
    }
  }

  const fetchBrandData = async () => {
    const brandDataState = dropdownDataState.brand
    let bodyData = {
      ...brandDataState,
    }
    delete bodyData["showMore"]

    let response = await ServiceAPI.postProductCommonData(
      API_END_POINTS.getAllBrands,
      bodyData,
      { isSaasEnable: localStorage.getItem("sourceRole")?.includes("SaaS") }
    )
    let { data: { data = {} } = {} } = response || {}
    let brandList = []
    data?.docs?.map((o) => brandList.push({ id: o._id, name: o.name }))
    if (brandDataState?.showMore === false) {
      setDropdownList((c) => ({
        ...c,
        brand: {
          ...c.brand,
          list: brandList,
          totalDocs: data.totalDocs,
          nextPage: data.nextPage,
        },
      }))
    } else {
      let addBrandList = dropDownList.brand.list
      addBrandList.push(...brandList)
      setDropdownList((c) => ({
        ...c,
        brand: {
          ...c.brand,
          list: addBrandList,
          totalDocs: data.totalDocs,
          nextPage: data.nextPage,
        },
      }))
    }
  }

  const fetchManufacturerData = async () => {
    const manufacturerDataState = dropdownDataState.manufacturer
    let bodyData = {
      ...manufacturerDataState,
    }
    delete bodyData["showMore"]
    let response = await ServiceAPI.postProductCommonData(
      API_END_POINTS.getAllManufacturers,
      bodyData,
      { isSaasEnable: localStorage.getItem("sourceRole")?.includes("SaaS") }
    )
    let { data: { data = {} } = {} } = response || {}
    let manufacturersList = []
    data?.docs?.map((o) => manufacturersList.push({ id: o._id, name: o.name }))
    if (manufacturerDataState?.showMore === false) {
      setDropdownList((c) => ({
        ...c,
        manufacturer: {
          ...c.manufacturer,
          list: manufacturersList,
          totalDocs: data.totalDocs,
          nextPage: data.nextPage,
        },
      }))
    } else {
      let addManufacturersList = dropDownList.manufacturer.list
      addManufacturersList.push(...manufacturersList)
      setDropdownList((c) => ({
        ...c,
        manufacturer: {
          ...c.manufacturer,
          list: addManufacturersList,
          totalDocs: data.totalDocs,
          nextPage: data.nextPage,
        },
      }))
    }
  }

  const handleDropdownSearchTerm = (searchVal, label) => {
    setDropdownDataState((c) => ({
      ...c,
      [label.toLowerCase()]: {
        ...c[label.toLowerCase()],
        searchTerm: searchVal,
        showMore: false,
        page: 1,
        limit: 10,
      },
    }))
  }

  const handleDropdownChange = (val, label) => {
    setDropdownSelectedItems((c) => ({ ...c, [label.toLowerCase()]: [...val] }))
  }

  const handleSearchTerm = (val) => {
    setSearchTerm(val)
  }

  const handleShowMore = async (label) => {
    const nxtPage = dropDownList && dropDownList[label.toLowerCase()].nextPage
    setDropdownDataState((c) => ({
      ...c,
      [label.toLowerCase()]: {
        ...c[label.toLowerCase()],
        limit: 10,
        page: nxtPage,
        showMore: true,
      },
    }))
  }

  const handleClear = () => {
    setSearchTerm("")
    setDropdownSelectedItems((c) => ({
      ...c,
      city: [],
      state: [],
      brand: [],
      manufacturer: [],
    }))
    if (sdcFilter)
      setSDCFilter([
        ...sdcFilter,
        {
          field: sdcFilter[0]?.field,
          operator: "eq",
          value: sdcFilter[0]?.value,
        },
      ])
  }

  let searchObj = {}
  if (lookupType === "location") {
    searchObj = {
      dropdown: [
        {
          label: "City",
          list: dropDownList.city.list,
          key: "name",
          filteredItems: dropDownSelectedItems.city,
          totalDocs: dropDownList?.city?.totalDocs,
          searchTerm: dropdownDataState.city.searchTerm,
        },
        {
          label: "State",
          list: dropDownList.state.list,
          key: "name",
          filteredItems: dropDownSelectedItems.state,
          totalDocs: dropDownList.state.totalDocs,
          searchTerm: dropdownDataState.state.searchTerm,
        },
      ],
      searchTerm: searchTerm,
    }
  } else {
    searchObj = {
      dropdown: [
        // {
        //   label: "Brand",
        //   list: dropDownList.brand.list,
        //   key: "name",
        //   filteredItems: dropDownSelectedItems.brand,
        //   totalDocs: dropDownList.brand.totalDocs,
        //   searchTerm: dropdownDataState.brand.searchTerm,
        // },
        // {
        //   label: "Manufacturer",
        //   list: dropDownList.manufacturer.list,
        //   key: "name",
        //   filteredItems: dropDownSelectedItems.manufacturer,
        //   totalDocs: dropDownList.manufacturer.totalDocs,
        //   searchTerm: dropdownDataState.state.searchTerm,
        // },
      ],
      searchTerm: searchTerm,
    }
  }

  const filterSelectedItems = {
    citySelectedItems: dropDownSelectedItems.city,
    stateSelectedItems: dropDownSelectedItems.state,
    brandSelectedItems: dropDownSelectedItems.brand,
    manufacturerSelectedItems: dropDownSelectedItems.manufacturer,
    searchTerm,
  }

  const handleLocationTypeFilter = (val) => {
    setSDCFilter([
      ...sdcFilter,
      { field: "locationType.name", operator: "eq", value: val },
    ])
  }

  let TitleHeading =
    lookupType === "product"
      ? "Product Lookup"
      : lookupType === "storage"
      ? "Storage Lookup"
      : "Store Lookup"

  let getDefaultListSaasData = () => {
    try {
      const storedStoreTypes = localStorage.getItem("selectedTenantStoreTypes")
      if (storedStoreTypes) {
        const parsedStoreTypes = JSON.parse(storedStoreTypes)
        if (Array.isArray(parsedStoreTypes) && !_.isEmpty(parsedStoreTypes)) {
          return parsedStoreTypes
        }
      }
    } catch (e) {}
    return null
  }
  const tenantSubSaasStoreTypeList = getStoreSelectedType ||
    getStoreType || [{ id: "STR_TY_001", name: "DIGITMART" }]
  const saasStoreTypeList = getDefaultListSaasData()
  let defaultGetStoreTypeList = localStorage
    .getItem("sourceRole")
    ?.includes("SaaS")
    ? saasStoreTypeList || tenantSubSaasStoreTypeList
    : tenantSubSaasStoreTypeList

  const lcGetStoreType = defaultGetStoreTypeList
  const renderTableUI = ({
    storeModeFilter = "DIGITMART",
    isShowHeader = true,
  } = {}) => (
    <div comp={TitleHeading} style={{ marginTop: 10 }}>
      <Table
        moduleType={moduleType}
        isLive={isLive}
        storeInfoView={storeInfoView}
        setLocationLMList={setLocationLMList}
        onUpdateTrigger={(innerPropsValue, type) => {
          localStorage.setItem(
            "paymentReaderlocationObjectData",
            JSON.stringify(innerPropsValue)
          )
          if (lookupType !== "product") {
            localStorage.setItem("selectedLocationMode", storeModeFilter || "")
            localStorage.setItem(
              "selectedLocationType",
              innerPropsValue[0].locationType?.name || ""
            )
            localStorage.setItem(
              "selectedLocationName",
              innerPropsValue[0].locationName
            )
            localStorage.setItem(
              "selectedLocationID",
              innerPropsValue[0].locationId
            )
          }
          onUpdateTrigger(innerPropsValue, storeModeFilter)
        }}
        isShowHeader={isShowHeader}
        storeModeFilter={storeModeFilter}
        getActiveFilter={getActiveFilter}
        isGridType={isGridType}
        isGrid={isGrid}
        pageName={pageName}
        columns={columns}
        lookupType={lookupType}
        hierarchyMapping={isLookUp ? false : true}
        isLookUp={isLookUp}
        preSelectedItems={selectedItems}
        triggerDataFetch={triggerDataFetch}
        setTriggerDataFetch={setTriggerDataFetch}
        dataFetchTriggerKey="categorized"
        onPrimaryActionClick={(x, cb) =>
          isLookUp
            ? handleLookUpPrimaryAction(x, cb)
            : disAssociateConformDialog(
                x,
                _.get(selectedHierarchyIds, "[0]"),
                cb
              )
        }
        fetchOnlyOnSelectedIdUpdate
        selectedHierarchyIds={selectedHierarchyIds}
        setHierarchySelectedIds={setHierarchySelectedIds}
        primaryActionLabel={
          isLookUp
            ? _.get(props, "primaryActionLabel", "ASSOCIATE")
            : "DISASSOCIATE"
        }
        title={
          lookupType === "storage"
            ? "Storage"
            : lookupType === "location"
            ? isLookUp
              ? "Stores"
              : "Stores Associated"
            : isLookUp
            ? "Products"
            : "Products Associated"
        }
        additionalFilters={[
          ...SDCFilter,
          {
            field:
              lookupType === "product"
                ? "product_mapped_category_id"
                : "locationHierarchy",
            operator: "eq",
            value: _.get(selectedHierarchyIds, "[0]", isLookUp ? "" : "*-*"),
          },
          {
            field: lookupType === "product" ? "isActive" : "isActive",
            operator: "eq",
            value: true,
          },
        ]}
        isInventory={isInventory}
        hideCheckBoxAll={hideCheckBoxAll}
        searchObj={searchObj}
        filterSelectedItems={filterSelectedItems}
        gridNoRecordsText={
          lookupType === "location"
            ? isLookUp
              ? notFoundText
              : "There are no Stores associated"
            : isLookUp
            ? notFoundText
            : "There are no products associated"
        }
        isWriteAllowed={isWriteAllowed}
        isDeleteAllowed={isDeleteAllowed}
        SDCFilter={SDCFilter}
        dataUniqueIdPath={dataUniqueIdPath}
        ShowCheckBox={ShowCheckBox}
        isKC={isKC}
        locationBasedProduct={locationBasedProduct}
      />
    </div>
  )

  const renderStoreInfo = (innerProps) => {
    const availableStoresCount =
      getLocationLMList?.total_available_stores ??
      getLocationLMList?.data?.total_available_stores ??
      getLocationLMList?.data?.data?.total_available_stores ??
      _.toFinite(props.availableStoresCount) ??
      0

    const systemIssueStoresCount =
      getLocationLMList?.total_stores_with_issues ??
      getLocationLMList?.data?.total_stores_with_issues ??
      getLocationLMList?.data?.data?.total_stores_with_issues ??
      _.toFinite(props.systemIssueStoresCount) ??
      0

    const cards = [
      {
        key: "available",
        title: "Available Stores",
        count: availableStoresCount,
        subtitle: "Show all available stores",
        Icon: StorefrontOutlined,
        accent: "#C2148A",
        iconBg: "#FBE6F4",
        activeBg: "#FDF3FA",
        activeBorder: "#E9A8D6",
      },
      {
        key: "systemIssues",
        title: "Store with System Issues",
        count: systemIssueStoresCount,
        subtitle: "Show stores with one or more system issues",
        Icon: ReportProblemOutlined,
        accent: "#E02B2B",
        iconBg: "#FDE7E7",
        activeBg: "#FDF4F3",
        activeBorder: "#F0B4AE",
      },
    ]

    return (
      <Grid
        container
        spacing={2}
        style={{
          padding: "12px 4px 4px 4px",
          width: "calc(100% - 8px) !important",
        }}
      >
        {cards.map(
          ({
            key,
            title,
            count,
            subtitle,
            Icon,
            accent,
            iconBg,
            activeBg,
            activeBorder,
          }) => {
            const isActive = storeInfoView === key
            return (
              <>
                <Grid item xs={12} sm={6} key={key}>
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={() => setStoreInfoView(key)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setStoreInfoView(key)
                      }
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 14,
                      padding: "14px 18px",
                      borderRadius: 12,
                      cursor: "pointer",
                      border: `1px solid ${
                        isActive ? activeBorder : "#ECECEC"
                      }`,
                      backgroundColor: isActive ? activeBg : "#FFFFFF",
                      boxShadow: isActive
                        ? `0 0 0 1px ${activeBorder}`
                        : "none",
                      transition: "all 0.15s ease-in-out",
                    }}
                  >
                    <div
                      style={{
                        flexShrink: 0,
                        width: 44,
                        height: 44,
                        borderRadius: "50%",
                        backgroundColor: iconBg,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon style={{ color: accent, fontSize: 24 }} />
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Typography
                        style={{
                          fontWeight: 600,
                          fontSize: 15,
                          color: "#1A1A1A",
                          lineHeight: 1.3,
                        }}
                      >
                        {`${title} (${_.toFinite(count)})`}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: 13,
                          color: "#6B6B6B",
                          marginTop: 2,
                        }}
                      >
                        {subtitle}
                      </Typography>
                    </div>
                  </div>
                </Grid>
              </>
            )
          }
        )}
        <div key={storeInfoView}>{renderTableUI(innerProps)}</div>
      </Grid>
    )
  }

  const renderTabUI = () => {
    
    return (
      <div
        style={{
          width: "100%",
          backgroundColor: "white",
          marginTop: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            paddingTop: 5,
            flexDirection: isMobile ? "row" : "row",
          }}
        >
          {lcGetStoreType.map((type, index) => {
            return (
              <Button
                style={{
                  borderBottom: `2px solid ${
                    index === getTabIndex
                      ? "var(--primaryColor)"
                      : "transparent"
                  } `,
                  borderRadius: 0,
                  marginRight: 5,
                  width: isMobile ? "100%" : "190px",
                  display: "flex",
                  height: 40,
                }}
                onClick={() => {
                  setTabIndex(index)
                }}
              >
                {type?.name}
              </Button>
            )
          })}
        </div>
        {lcGetStoreType.map((type, index) => {
          return (
            <>
              {index === getTabIndex && (
                <div>
                  {moduleType === "store" &&
                    renderStoreInfo({
                      storeModeFilter: type?.name,
                      isShowHeader: false,
                    })}
                  {moduleType !== "store" &&
                    renderTableUI({
                      storeModeFilter: type?.name,
                      isShowHeader: false,
                    })}
                </div>
              )}
            </>
          )
        })}
      </div>
    )
  }

  return (
    <>
      <ConfirmationDialog
        openConfirmationDialog={openConfirmationDialog}
        setOpenConfirmationDialog={setOpenConfirmationDialog}
        setReDirect={setReDirect}
        handleCustomCloseRedirect={handleCustomCloseRedirect}
        deleteContent={
          lookupType === "product"
            ? "Do you really want to Disassociate selected Product(s) from the category?"
            : "Do you really want to Disassociate selected Store(s) from the hierarchy?"
        }
      />

      {history?.location?.pathname?.includes("productMapping") ? (
        <div style={{ borderBottom: "1px solid #E0E0E0", width: "100%" }}>
          <Helmet title="Product Mapping" />
          <PageHeaderBreadcrumbKit
            container
            justify="space-between"
            alignContent="center"
            alignItems="center"
            className="PageHeaderBreadcrumbKit"
          >
            <Grid>
              <TenantBreadcrumb
                list={[
                  { name: "Master Data", disable: true },
                  { name: "Products", disable: true },
                ]}
                breadcrumbTabName="Category Mapping"
                tenantUrl="master-data/products_pm/productMapping"
                showRealm={true}
                fallbackList={BreadcrumbList1}
              />
            </Grid>
          </PageHeaderBreadcrumbKit>
          <Typography
            style={{
              background: "#ffff",
              fontWeight: 600,
              fontSize: "20px",
              padding: "10px 10px",
            }}
          >
            {`Product Mapping`}
          </Typography>
        </div>
      ) : null}
      {history?.location?.pathname?.includes("hierarchyMapping") ? (
        <div style={{ borderBottom: "1px solid #E0E0E0", width: "100%" }}>
          <Helmet title="Stores Mapping" />
          <PageHeaderBreadcrumbKit
            container
            justify="space-between"
            alignContent="center"
            alignItems="center"
            className="PageHeaderBreadcrumbKit"
          >
            <Grid>
              <TenantBreadcrumb
                list={[
                  { name: "Master Data", disable: true },
                  { name: "Stores", disable: true },
                ]}
                breadcrumbTabName="Hierarchy Mapping"
                tenantUrl="master-data/locations_hm/hierarchyMapping"
                // tenantUrl="master-data/locations_hp/hierarchyMapping"
                showRealm={true}
                fallbackList={BreadcrumbList}
              />
            </Grid>
          </PageHeaderBreadcrumbKit>
          <Typography
            style={{
              fontWeight: 600,
              background: "#ffff",
              fontSize: "20px",
              padding: "10px 10px",
            }}
          >
            {`Stores Mapping`}
          </Typography>
        </div>
      ) : null}

      <div
        style={{
          height: isLookUp ? "" : "",
          overflowY: "auto",
          background: "transparent",
          width: "100%",
        }}
      >
        <div
          style={{
            ...(isLookUp ? {} : { height: "100%" }),
            border: "0px solid red",
            display: "flex",
            flexGrow: 1,
            flexWrap: "wrap",
            alignContent: "flex-start",
          }}
        >
          {!isLookUp ? (
            <></>
          ) : (
            <>
              {isGridType !== "2" && (
                <Grid
                  container
                  alignItems="center"
                  style={{
                    height: 48,
                    paddingInline: 16,
                    borderBottom: `1px solid #c0c0c0`,
                  }}
                >
                  <Grid item xs={10}>
                    <Typography variant="h4">{TitleHeading}</Typography>
                  </Grid>

                  {isNotModalView === false && (
                    <Grid item xs={2} container justify="flex-end">
                      <Tooltip title="Close" placement="top">
                        <IconButton size="small" onClick={handleCloseLookUp}>
                          <CloseRounded />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  )}
                </Grid>
              )}
            </>
          )}

          <Adm.BackdropOverlay open={loading} />
          <Grid
            container
            style={{
              height: isLookUp ? "" : "calc(100% - 100px)",
              overflow: "hidden",
            }}
          >
            {isNotModalView === false && (
              <Grid
                item
                xs={isLookUp ? 4 : 5}
                style={{
                  borderRight: "1px solid #c0c0c0",
                  display: toggle ? "block" : isLookUp ? "none" : "",
                }}
              >
                <Hierarchy
                  isWriteAllowed={isWriteAllowed}
                  isDeleteAllowed={isDeleteAllowed}
                  lookupType={lookupType}
                  isViewMode
                  titlePath={titlePath}
                  idPath={idPath}
                  parentIdPath={parentIdPath}
                  canSelectOnlyLastLevel
                  isMappingMode
                  updateSelectedIds={(ids) => setHierarchySelectedIds(ids)}
                />
              </Grid>
            )}
            <Grid
              item
              container
              xs={isNotModalView ? 12 : isLookUp ? (toggle ? 8 : 12) : 7}
              style={{
                flexFlow: "nowrap column",
                paddingRight: isNotModalView
                  ? "0px"
                  : toggle
                  ? "20px"
                  : isLookUp
                  ? "50px"
                  : "0px",
                height: "100%",
                borderLeft: isNotModalView
                  ? "0px solid #e8e8e8"
                  : toggle
                  ? ""
                  : isLookUp
                  ? "1px solid #e8e8e8"
                  : "",
                marginLeft: isNotModalView
                  ? "0px"
                  : toggle
                  ? ""
                  : isLookUp
                  ? "50px"
                  : "",
              }}
            >
              {isLookUp && (
                <Grid
                  style={{
                    padding: "10px",
                    borderBottom: "1px solid #EEEEEE",
                    position: "relative",
                    backgroundColor: "#fff",
                  }}
                  className="cls-hierarchy-mapping-mobil-view-ui"
                >
                  {isNotModalView === false && (
                    <div
                      onClick={handleClick}
                      style={{
                        width: "30px",
                        height: "30px",
                        background: "var(--primaryColor)",
                        position: "absolute",
                        top: "14px",
                        borderRadius: "50%",
                        left: "-40px",
                        cursor: "pointer",
                      }}
                    >
                      {toggle ? (
                        <NavigateBeforeOutlinedIcon
                          style={{
                            width: "30px",
                            height: "30px",
                            color: "#fff",
                          }}
                        />
                      ) : (
                        <NavigateNextOutlinedIcon
                          style={{
                            width: "30px",
                            height: "30px",
                            color: "#fff",
                          }}
                        />
                      )}
                    </div>
                  )}

                  <SearchBar
                    dropDownSelectedItems={dropDownSelectedItems}
                    defaultActiveFilterValue={getActiveFilter}
                    handleActiveFilter={(value) => {
                      setActiveFilter(value)
                    }}
                    isGridType={isGridType}
                    flag={TitleHeading.includes("Store Lookup")}
                    handleClear={handleClear}
                    handleShowMore={handleShowMore}
                    handleSearchTerm={handleSearchTerm}
                    handleDropdownSearchTerm={handleDropdownSearchTerm}
                    dropdownData="State"
                    searchObj={searchObj}
                    handleDropdownChange={handleDropdownChange}
                    handleLocationTypeFilter={handleLocationTypeFilter}
                    lookupType={lookupType}
                    locationTypeList={
                      sdcFilter[0]?.field === "locationType.name" &&
                      sdcFilter[0]?.value?.length > 0
                        ? sdcFilter[0]?.value
                        : locationTypeList
                    }
                  />
                </Grid>
              )}
              {!isLookUp ? (
                <>
                  <div
                    className={
                      lookupType === "location"
                        ? "cls-lookup-kit-store"
                        : lookupType === "storage"
                        ? "cls-lookup-kit-storage"
                        : "cls-lookup-kit-product"
                    }
                    style={{
                      minHeight: 300,
                      height: "50%",
                      display: "flex",
                      flexGrow: 1,
                      border: "0px solid red",
                    }}
                  >
                    <Table
                      getActiveFilter={getActiveFilter}
                      isGridType={isGridType}
                      isGrid={isGrid}
                      columns={columns}
                      hierarchyMapping={true}
                      lookupType={lookupType}
                      selectedHierarchyIds={selectedHierarchyIds}
                      triggerDataFetch={triggerDataFetch}
                      setTriggerDataFetch={setTriggerDataFetch}
                      dataFetchTriggerKey="uncategorized"
                      title={
                        lookupType === "location"
                          ? "Uncategorized Store"
                          : lookupType === "storage"
                          ? "Uncategorized Storage"
                          : "Uncategorized Product"
                      }
                      onPrimaryActionClick={(x, cb) =>
                        handleMapping(x, _.get(selectedHierarchyIds, "[0]"), cb)
                      }
                      additionalFilters={[
                        ...SDCFilter,
                        {
                          field:
                            lookupType === "product"
                              ? "product_mapped_category_id"
                              : "locationHierarchy",
                          operator: "eq",
                          value: "",
                        },
                        {
                          field:
                            lookupType === "product" ? "isActive" : "isActive",
                          operator: "eq",
                          value: true,
                        },
                      ]}
                      isInventory={isInventory}
                      hideCheckBoxAll={hideCheckBoxAll}
                      searchObj={searchObj}
                      gridNoRecordsText={
                        lookupType === "location"
                          ? isLookUp
                            ? ""
                            : notFoundText
                          : isLookUp
                          ? ""
                          : notFoundText
                      }
                      isWriteAllowed={isWriteAllowed}
                      isDeleteAllowed={isDeleteAllowed}
                      preSelectedItems={selectedItems}
                      SDCFilter={SDCFilter}
                      dataUniqueIdPath={dataUniqueIdPath}
                      ShowCheckBox={ShowCheckBox}
                      isKC={isKC}
                      locationBasedProduct={locationBasedProduct}
                    />
                  </div>
                </>
              ) : null}
              <div
                className={
                  lookupType === "location"
                    ? isLookUp
                      ? "cls-lookup-kits-stores cls-lookup-kits-grid-kit"
                      : "cls-lookup-kits-stores-associated cls-lookup-kits-grid-kit"
                    : isLookUp
                    ? "cls-lookup-kits-products cls-lookup-kits-grid-kit"
                    : "cls-lookup-kits-products-associated cls-lookup-kits-grid-kit"
                }
                style={{
                  minHeight: "480px",
                  maxHeight: isNotModalView ? "unset" : "480px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  marginBottom: "30px",
                  height: isLookUp ? "100%" : "50%",
                  border: "0px solid red",
                }}
              >
                {TitleHeading.includes("Store Lookup")
                  ? renderTabUI()
                  : renderTableUI()}
              </div>
            </Grid>
          </Grid>
        </div>
        {alert ? (
          <Adm.SnackBar open={true} message={alertMessage} type={alertType} />
        ) : null}
      </div>
    </>
  )
}

export default HierarchyMapping
